import { post } from '@/api';

export async function postProposal(data: any) {
  return (await post('api/widget/proposal', data)).body.data;
}

export async function sendProposal(id: any, data = {}) {
  return (await post('api/widget/proposal/send', { id, ...data })).body.data;
}

export async function submitProposal(id: any) {
  return (await post('api/widget/proposal/submit', { id })).body.data;
}
